import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';
import TableUI from "../components/TableUI";

const DetailedReport = () => {
  const location = useLocation();
  const { agent_name, customer_name,data } = location.state || {};

  const [detailedData, setDetailedData] = useState(data);

  console.log(detailedData,'siva');


  const reportHead = ["Invoice No", "Date", "Description", "Total", "Amount"];

  return (
    <div id="main">
      <Container>
        <Row>
          <Col lg="12" className="py-3">
            <PageTitle PageTitle={`Detailed Report for ${agent_name} - ${customer_name}`} showButton={false} />
          </Col>
          <Col xs="12" className="py-3">
            <TableUI
              headers={reportHead}
              body={detailedData}
              showActionColumn={false}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DetailedReport;
